import { UPDATE_USER_DATA } from "../actions";

const defaultState = {
    userData: [],
    userDataLoading: true
}

const userDataReducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_USER_DATA:
            return {
                ...state,
                userData: action.payload.userData,
                userDataLoading: action.payload.userDataLoading
            }
        default: return state
    }
}

export default userDataReducer;